import React from 'react';
import PropTypes from 'prop-types';
import { useAtom } from 'jotai';
import { Themes, Autocomplete, RenderValueTypes } from '@cyberint/dsc';
import { t } from '@cyberint/stateful-ui/i18n';
import { victimologyTempFiltersState } from '@cyberint/stateful-ui/victimology/VictimologyTable/store/atoms';

export const MultiSelect = ({ accessor, options }) => {
  const [tempFilters, setTempFilters] = useAtom(victimologyTempFiltersState);

  const onChangeHandler = (value, clear) => {
    const newValue = clear?.isClear ? [] : value;
    setTempFilters({ ...tempFilters, [accessor]: newValue });
  };

  return (
    <Autocomplete
      label={t(`victimology.filters.${accessor}`)}
      onChange={onChangeHandler}
      options={options}
      value={tempFilters?.[accessor]}
      disablePortal={false}
      width="320px"
      mode={Themes.LIGHT}
      renderValue={RenderValueTypes.COMMA_SEPARATED}
      multiple
      clearable
    />
  );
};

MultiSelect.propTypes = {
  accessor: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};
